import React from "react";
import ChartCard from "./ChartCard";
import LineChart from "../charts/Line";

export default class AppliancesAddedPerMonthCard extends React.Component{
    render(){
        return (
            <ChartCard title="Appliances added per month">
                <LineChart resource="added-appliances"/>
            </ChartCard>
        )
    }
}